/* MB Machinery - theme scripts */
(function () {
  'use strict';

  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(msg) {
    toastEl = toastEl || qs('#MBToast');
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }
  window.MBToast = toast;

  /* ---------- Sticky header schaduw ---------- */
  function initStickyHeader() {
    var header = qs('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers (menu, winkelwagen) ---------- */
  var lastFocused = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('button, a, input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function initDrawers() {
    qsa('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer(qs('#' + btn.getAttribute('data-drawer-open')));
      });
    });
    qsa('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer(btn.closest('.drawer, .search-panel'));
      });
    });
    qsa('.drawer__overlay').forEach(function (ov) {
      ov.addEventListener('click', function () { closeDrawer(ov.closest('.drawer')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      qsa('.drawer.is-open, .search-panel.is-open').forEach(closeDrawer);
    });
  }

  /* ---------- Zoekpaneel ---------- */
  function initSearch() {
    var panel = qs('#SearchPanel');
    if (!panel) return;
    qsa('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var input = panel.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 90);
      });
    });
    panel.addEventListener('click', function (e) {
      if (e.target === panel) closeDrawer(panel);
    });
  }

  /* ---------- Productgalerij ---------- */
  function initGallery() {
    qsa('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        e.preventDefault();
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset);
        main.setAttribute('alt', alt);
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Aantal ---------- */
  function initQty() {
    qsa('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn) return;
        e.preventDefault();
        var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Variantkiezer ---------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var amount = parts.join(',');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    return '€ ' + amount;
  }

  function initVariants() {
    qsa('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form') || document.querySelector('[data-product-form]');
      var dataEl = document.getElementById(picker.getAttribute('data-variants'));
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      picker.addEventListener('change', function () {
        var selected = qsa('input:checked', picker).map(function (i) { return i.value; });
        var match = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        })[0];

        var idInput = form && form.querySelector('[name="id"]');
        var submit = form && form.querySelector('[data-add-to-cart]');
        var priceEl = document.querySelector('[data-price-amount]');
        var compareEl = document.querySelector('[data-price-compare]');

        if (!match) {
          if (submit) {
            submit.setAttribute('disabled', 'disabled');
            submit.textContent = window.MBTheme.strings.unavailable;
          }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price, window.MBTheme.moneyFormat);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price, window.MBTheme.moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submit) {
          if (match.available) {
            submit.removeAttribute('disabled');
            submit.textContent = window.MBTheme.strings.addToCart;
          } else {
            submit.setAttribute('disabled', 'disabled');
            submit.textContent = window.MBTheme.strings.soldOut;
          }
        }
        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Winkelwagen aantallen ---------- */
  function initCart() {
    qsa('[data-cart-update]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });
    qsa('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-cart-remove');
        var input = document.querySelector('[data-cart-qty="' + line + '"]');
        if (input) {
          input.value = 0;
          var form = input.closest('form');
          if (form) form.submit();
        }
      });
    });
  }

  /* ---------- Filters mobiel ---------- */
  function initFacets() {
    qsa('[data-facets-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = qs('[data-facets-wrap]');
        if (wrap) wrap.classList.toggle('is-open');
      });
    });
    qsa('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- Sorteren ---------- */
  function initSort() {
    qsa('[data-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Scroll animaties ---------- */
  function initAnimations() {
    if (!window.MBTheme || !window.MBTheme.animations) return;
    if (!('IntersectionObserver' in window)) {
      qsa('[data-anim]').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-anim-delay'), 10) || 0;
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    qsa('[data-anim]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Marquee verdubbelen ---------- */
  function initMarquee() {
    qsa('[data-marquee-track]').forEach(function (track) {
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initStickyHeader();
    initDrawers();
    initSearch();
    initGallery();
    initQty();
    initVariants();
    initCart();
    initFacets();
    initSort();
    initAnimations();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
